import React from 'react';
import { DialogActions, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

function DialogAccionesCerrarBienestar({ onClick }) {
    const theme = useTheme();
    const pantallaCelular = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <DialogActions
            style={{
                flexShrink: 0,
                padding: '10px 16px',
                borderTop: '1px solid rgba(0,0,0,0.08)',
                justifyContent: pantallaCelular ? 'stretch' : 'flex-end',
            }}
        >
            <Button variant="outlined" color="primary" fullWidth={pantallaCelular} onClick={onClick}>
                Cerrar
            </Button>
        </DialogActions>
    );
}

export default React.memo(DialogAccionesCerrarBienestar);
